import { AiGeneratingUI } from '../../AiGeneratingUI';
import { useAiGenerateMultipleStatusValue } from '../useAiGenerateMultipleStatus';
export const AiChoiceListGenerationOverlay = () => {
  const {
    isGeneratingBulk
  } = useAiGenerateMultipleStatusValue();
  return <AiGeneratingUI.BulkOptions isVisible={isGeneratingBulk} data-sentry-element="unknown" data-sentry-component="AiChoiceListGenerationOverlay" data-sentry-source-file="AiChoiceListGenerationOverlay.tsx" />;
};